<div class="product-section-page">
    <!-- <app-full-screen-header></app-full-screen-header> -->
    <div class="inner">
        <div class="product-selector-wrapper">
            <h1>Choose a product to continue</h1>
            <ul>
                <li><a href="#">Electrophysiology</a></li>
                <li><a href="#">Trauma</a></li>
            </ul>
            <mat-checkbox class="example-margin">Make the selection as default</mat-checkbox>
        </div>
    </div>
    
</div>